import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  path?: string;
};

type BreadcrumbsProps = {
  items: Crumb[];
};

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs md:text-sm text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.path && !isLast ? (
                <Link to={item.path} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}